import React, { useEffect, useState } from 'react';
import { schoolLogoSrc } from '../utils/schoolLogo';

const SPLASH_KEY = 'mps-welcome-splash-seen';

export default function WelcomeSplash({ onDone }) {
  const [visible, setVisible] = useState(() => {
    try {
      return !sessionStorage.getItem(SPLASH_KEY);
    } catch {
      return true;
    }
  });
  const [fade, setFade] = useState(false);

  useEffect(() => {
    if (!visible) {
      onDone?.();
      return undefined;
    }
    const fadeTimer = setTimeout(() => setFade(true), 2200);
    const hideTimer = setTimeout(() => {
      try {
        sessionStorage.setItem(SPLASH_KEY, '1');
      } catch {
        /* ignore */
      }
      setVisible(false);
      onDone?.();
    }, 2800);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(hideTimer);
    };
  }, [visible, onDone]);

  if (!visible) return null;

  return (
    <div className={`mps-welcome-splash${fade ? ' mps-welcome-splash-fade' : ''}`} role="dialog" aria-label="Welcome">
      <div className="mps-welcome-splash-card">
        <div className="mps-welcome-splash-glow" aria-hidden="true" />
        <div className="mps-app-logo-wrap mps-app-logo-wrap-lg mps-welcome-splash-logo" aria-hidden="true">
          <img src={schoolLogoSrc()} alt="" width={80} height={80} />
        </div>
        <p className="mps-welcome-splash-sign" aria-hidden="true">🙏</p>
        <h1 className="mps-welcome-splash-title">Welcome to</h1>
        <p className="mps-welcome-splash-school">MODERN PUBLIC SCHOOL APP</p>
        <p className="mps-welcome-splash-tagline">Serve Mankind to Serve God</p>
        <div className="mps-welcome-splash-bar" aria-hidden="true">
          <span className="mps-welcome-splash-bar-fill" />
        </div>
      </div>
    </div>
  );
}
